import { routes } from "./routes";
import { createBrowserRouter } from "react-router-dom";

export const router = createBrowserRouter(routes, {
  basename: process.env.REACT_APP_BASENAME_URL,
});
